module.exports = __webpack_public_path__ + "static/about-79eb8eaa8a9ec6b9b11df041bc46b1c1.svg";